import { Button } from '@/components/button';
import { Modal, ModalBody, ModalButtonContainer } from '@/components/modal/modal';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import { useTranslation } from '@/contexts/i18n-context';
import styles from './identity-verification-reset-modal.module.css';

interface IdentityVerificationResetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export function IdentityVerificationResetModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: IdentityVerificationResetModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOutsideClick>
      <MaterialSymbolIcon name="warning" className={styles.modalIcon} />
      <h2 className="h4">{t('identityVerificationWarnings.modal.title')}</h2>
      <ModalBody>
        <p>{t('identityVerificationWarnings.modal.description')}</p>
      </ModalBody>
      <ModalButtonContainer>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          {t('common.cancel')}
        </Button>
        <Button onClick={onConfirm} loading={isLoading}>
          {t('common.saveChanges')}
        </Button>
      </ModalButtonContainer>
    </Modal>
  );
}
